import React, {useEffect, useState} from 'react';
import {XMarkIcon} from '@heroicons/react/24/outline';
import styles from './UpdatePopUp.module.css';
import Button from "../../../components/common/button/Button";
import {getTermAPI} from "../../../services/term";
import {updateTermAPI} from "../../../services/admin";

interface UpdateTermPopUpProps {
    isOpen: boolean;
    onClose: () => void;
}

//데이터 사업 규정 수정 팝업
const UpdateTermPopUp: React.FC<UpdateTermPopUpProps> = ({isOpen, onClose}) => {
    const [term, setTerm] = useState<string>('');
    const [loading, setLoading] = useState(true);

    const handleSubmit = async () => {
        try {
            // 데이터 사업 규정 수정 API
            await updateTermAPI({content: term});
        } catch (error) {
            console.error('Error update term request:', error);
        }
        fetchTerm();
        onClose();
        window.location.reload();
    };

    const fetchTerm = async () => {
        try {
            setLoading(true);
            //데이터 사업 규정 조회 API
            const response = await getTermAPI();
            setTerm(response);
        } catch (error) {
            console.error('Error fetching term request:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchTerm();
    }, []);

    if (!isOpen) return null;

    if (loading) {
        return <div className={styles.loading}>Loading...</div>;
    }

    return (
        <div className={styles.overlay}>
            <div className={styles.modal}>
                <div className={styles.header}>
                    <h2 className={styles.title}>데이터 사업 규정 작성</h2>
                    {/*팝업 닫기 버튼*/}
                    <button onClick={onClose} className={styles.closeButton}>
                        <XMarkIcon className={styles.closeIcon}/>
                    </button>
                </div>
                <div className={styles.content}>
                    <div className={styles.formGroup}>
                        <label>데이터 사업 규정</label>
                        {/*데이터 사업 규정 입력*/}
                        <textarea
                            value={term}
                            onChange={(e) => setTerm(e.target.value)}
                            placeholder="데이터 사업 규정을 적어주세요"
                            className={styles.textarea}
                        />
                    </div>
                </div>

                <div className={styles.footer}>
                    {/*저장 버튼*/}
                    <Button
                        variant="primary"
                        onClick={handleSubmit}
                        disabled={!term?.trim()}
                        className={styles.submitButton}
                    >
                        저장
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default UpdateTermPopUp;